import { render } from "./SelectCore.vue?vue&type=template&id=4cb28640&ts=true"
import script from "./SelectCore.vue?vue&type=script&lang=ts"
export * from "./SelectCore.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__